import { httpClient } from '@/services/http/httpClient'

export type UpdateCommentVideoParams = {
  text: string
  commentId: string
  videoId?: number
}

export async function updateComment({
  text,
  commentId,
  videoId,
}: UpdateCommentVideoParams) {
  const { data } = await httpClient.put('/users/videos/comments', {
    text,
    commentId,
    videoId,
  })

  return data
}
